var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.journey)?void 0:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }